import Vue from 'vue'

export default Vue.directive('focus', {
  bind: function (el, binding, vnode) {
    el.addEventListener(binding.arg || 'click', function () {
      vnode.context.$trackEvent(binding.value)
    })
  }
})
